import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
    success: [],
    info: [],
    warning: [],
    error: [],
    interfaceMessages: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
